<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ adminObject.name }}</strong>
                </CCardHeader>
                <CCardBody>
                    <AdministratorsTabLinks />
                    <CRow class="pl-3 pb-3" />

                    <CDataTable
                        small
                        fixed
                        :header="false"
                        :items="visibleData"
                        :fields="fields"
                    />
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="goBack">Назад</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="showEditModal"
                    >Редактировать</CButton
                    >
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="passwordModal.show = true"
                    >Изменить пароль</CButton
                    >
                    <CButton
                        color="danger"
                        class="mr-3"
                        @click="deleteModal = true"
                    >Удалить</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>

        <CModal
            title="Подтверждение"
            color="danger"
            :show.sync="deleteModal"
            :footer="false"
        >
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p>
                        Вы действительно хотите удалить администратора? Это действие нельзя
                        будет отменить.
                    </p>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="deleteModal = false"
                    >Отмена</CButton
                    >
                    <CButton
                        color="danger"
                        class="ml-3"
                        @click="deleteAdmin"
                    >Удалить</CButton
                    >
                </div>
            </template>
        </CModal>

        <CModal
            title="Изменение пароля"
            :show.sync="passwordModal.show"
            :footer="false"
        >
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <CForm>
                        <CInput
                            v-model="passwordModal.password"
                            label="Пароль"
                            placeholder="Введите пароль"
                            type="password"
                            horizontal
                            autocomplete="new-password"
                        />
                        <CInput
                            v-model="passwordModal.password2"
                            label="Подтверждение"
                            placeholder="Введите пароль еще раз"
                            type="password"
                            horizontal
                            autocomplete="new-password"
                        />
                    </CForm>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="passwordModal.show = false"
                    >Отмена</CButton
                    >
                    <CButton
                        color="primary"
                        class="ml-3"
                        @click="adminPasswordChange"
                    >Изменить</CButton
                    >
                </div>
            </template>
        </CModal>

        <CModal
            title="Редактирование"
            :show.sync="editModal.show"
            :footer="false">
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <CForm>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label"> Имя </CCol>
                            <CCol sm="9">
                                <CInput v-model="editModal.name" />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label"> Активен </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="light"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="editModal.enabled"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="editModal.show = false"
                    >Отмена</CButton
                    >
                    <CButton
                        color="primary"
                        class="ml-3"
                        @click="updateAdmin"
                    >Изменить</CButton
                    >
                </div>
            </template>
        </CModal>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import AdministratorsTabLinks from '@/components/AdministratorsTabLinks';

    export default {

        name: 'Administrator',
        components: {
            AdministratorsTabLinks,
        },

        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.administratorsOpened = from.fullPath.includes('administrators');
            });
        },

        data() {
            return {
                administratorsOpened: null,
                adminObject: {},
                deleteModal: false,
                passwordModal: {
                    show: false,
                    password: '',
                    password2: '',
                },
                editModal: {
                    show: false,
                    name: '',
                    enabled: false,
                },
            };
        },

        computed: {
            fields() {
                return [
                    { key: 'key', label: '' },
                    { key: 'value', label: '' },
                ];
            },
            visibleData() {
                const adminDetails = Object.entries(this.adminObject);
                return adminDetails.map(([key, value]) => {
                    return { key: fieldTitle(key), value: fieldValue(value) };
                });
            },
        },

        mounted() {
            const id = this.$route.params.id;
            Vue.axios
                .get('/administrators/' + id)
                .then(resp => {
                    this.adminObject = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },
        methods: {
            goBack() {
                this.administratorsOpened
                    ? this.$router.go(-1)
                    : this.$router.push({ path: '/administrators' });
            },
            deleteAdmin() {
                Vue.axios
                    .delete('/administrators/' + this.adminObject.id)
                    .then(resp => {
                        this.goBack();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка удаления администратора.');
                    });
            },
            adminPasswordChange() {
                if (!this.passwordModal.password || !this.passwordModal.password2) {
                    this.$root.$emit('showError', 'Введите пароль и подтверждение.');
                    return;
                }
                if (this.passwordModal.password !== this.passwordModal.password2) {
                    this.$root.$emit('showError', 'Пароли должны совпадать.');
                    return;
                }
                if (this.passwordModal.password.length < 6) {
                    this.$root.$emit('showError', 'Пароль должен содержать минимум 6 символов.');
                    return;
                }
                Vue.axios
                    .post('/administrators/password/' + this.adminObject.id, {
                        password: this.passwordModal.password,
                    })
                    .then(resp => {
                        this.passwordModal.password = this.passwordModal.password2 = '';
                        this.passwordModal.show = false;
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Не удалось сохранить пароль.');
                    });
            },
            showEditModal() {
                this.editModal.name = this.adminObject.name;
                this.editModal.enabled = this.adminObject.enabled;
                this.editModal.show = true;
            },
            updateAdmin() {
                if (!this.editModal.name) {
                    this.$root.$emit('showError', 'Имя администратора не может быть пустым.');
                    return;
                }
                Vue.axios
                    .post('/administrators/update/' + this.adminObject.id, {
                        name: this.editModal.name,
                        enabled: this.editModal.enabled,
                    })
                    .then(resp => {
                        this.adminObject = resp.data;
                        this.editModal.show = false;
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Не удалось сохранить администратора.');
                    });
            },
        },
    };

    function fieldTitle(field) {
        switch (field) {
        case 'id':
            return 'ID';
        case 'name':
            return 'Имя';
        case 'email':
            return 'Email';
        case 'enabled':
            return 'Активен';
        default:
            return field;
        }
    }

    function fieldValue(value) {
        if (typeof value === 'boolean') {
            return value ? 'Да' : 'Нет';
        } else {
            return value;
        }
    }
</script>
